import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
     
      // 默认打开一个标签页
      activeName: "1",
      /******************************区管单位********************************* */
      // 列表loading状态
      loading: false,
      // 表头按钮组
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 查询表单字段
      form: {
        code: null, // 区管代码
        name: null, // 区管名称
        borrowFlag: null, // 借平台标志
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "区管名称：",
          value: "name",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "区管代码：",
          value: "code",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "借平台标志：",
          value: "borrowFlag",
          placeholder: "请输入",
          clearable: true,
          optionData: [
            { name: "本平台", value: "0" },
            { name: "借平台", value: "1" },
          ]
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "区管名称",
          prop: "name",
          isShow: true,
        },
        {
          label: "区管代码",
          prop: "code",
        },
        {
          label: "借平台标志",
          slotName: "borrowFlag",
        },
        {
          label: "市区标志",
          slotName: "citySign",
        },
      ],
      // 表格数据
      tableData: [],
      multipleSelection: [], // 勾选数组
      /******************************区管部门********************************* */
      // 列表loading状态
      departmentLoading: false,
      // 表头按钮组
      departmentBtnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 分页
      departmentReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      departmentTotal: 0, // 总条数
      // 查询表单字段
      departmentForm: {
        zoneCode: null, // 区管代码
        borrowFlag: null, // 借平台标志
        departmentCode: null, // 部门代码
        departmentName: null, // 部门名称
      },
      // 查询表单
      departmentFormSearchList: [
        {
          type: "select",
          label: "区管单位：",
          value: "zoneCode",
          placeholder: "请输入",
          queryParams: {
            url: "/zoneCode/ZoneCodeCombobox",
          }
        },
        {
          type: "select",
          label: "借平台标志：",
          value: "borrowFlag",
          placeholder: "请输入",
          clearable: true,
          optionData: [{
              name: "本平台",
              value: "0"
            },
            {
              name: "借平台",
              value: "1"
            },
          ]
        },
        {
          type: "input",
          label: "部门代码：",
          value: "departmentCode",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "input",
          label: "部门名称：",
          value: "departmentName",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格基础数据
      departmentTableColumns: [
        {
          label: "部门名称",
          prop: "departmentName",
          isShow: true,
        },
        {
          label: "部门代码",
          prop: "departmentCode",
          width: "100px",
        },
        {
          label: "区管单位",
          prop: "zoneName",
        },
        {
          label: "缴费交易中心",
          prop: "tradingCenterName",
        },
        {
          label: "行政区划",
          prop: "areaCodeName",
          width: "150px",
        },
        {
          label: "借平台标志",
          prop: "borrowFlag",
          width: "150px",
        },

      ],
      // 表格数据
      departmentTableData: [],
      departmentMultipleSelection: [], // 勾选数组
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 查询一览数据
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 点击切换标签页
     * @author shuhua
     */
    handleClick() {
      // 切换显示列
      this.fun_SetTableColumns();
    },
    /**
     * 切换列表显示列
     * @author shuhua
     */
    fun_SetTableColumns() {
      // 区管单位
      if (this.activeName == "1") {
        // 获取一览表格数据
        this.fun_GetList();
      }
      // 区管部门
      else {
        // 获取一览表格数据
        this.fun_GetDepartmentList();
      }
    },
    /*******************************区管单位**************************** */
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/zoneCode/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     */
    fun_Reset(){
      // 清空表单
      this.form = {
        code: null, // 区管代码
        name: null, // 区管名称
        borrowFlag: null, // 借平台标志
      }
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          this.fun_Add();
          break;
        case "修改":
          this.fun_Edit();
          break;
        case "删除":
          this.fun_Del();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_Details(e) {
      // 跳转详情页面
      this.$router.push({
        path: "/zoneCodeDetail",
        // 操作类型
        query: {
          id: e.val.id, // 主键
          type: "details", // 操作类型
          flag: "1", // 标志
        }
      });
    },
    /**
     * 点击新增按钮
     */
    fun_Add() {
      // 跳转详情页面
      this.$router.push({
        path: "/zoneCodeDetail",
        // 操作类型
        query: {
          type: "insert", // 操作类型
          flag: "1", // 标志
        }
      });
    },
    /**
     * 点击修改按钮
     */
    fun_Edit() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0){
        // 如果勾选超过1条
        if(this.multipleSelection.length > 1){
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        }else{
          // 跳转详情页面
          this.$router.push({
            path: "/zoneCodeDetail",
            // 操作类型
            query: {
              id: this.multipleSelection[0].id, // 主键
              type: "update", // 操作类型
              flag: "1", // 标志
            }
          });
        }
      }
    },
    /**
     * 删除
     */
    fun_Del(){
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for(const index in this.multipleSelection ){
          // 赋值主键集合
          keys[index] = this.multipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/zoneCode/delete", {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 获取一览表格数据
            this.fun_GetList();
          });
        });
      }
      // 如果未进行勾选
      else{
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
    /*******************************区管部门**************************** */
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetDepartmentList() {
      try {
        // 打开loading
        this.departmentLoading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/zoneDepartment/list", {
          ...this.departmentForm,
          ...this.departmentReqPageData
        });
        // 解构res.data
        const {result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.departmentTableData = records;
          // 获取分页总条数
          this.departmentTotal = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.departmentLoading = false;
      } catch {
        // 关闭loading
        this.departmentLoading = false;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_DepartmentSearch() {
      // 重置分页
      this.departmentReqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetDepartmentList();
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_DepartmentLimitChange(e) {
      // 获取每页显示条数
      this.departmentReqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetDepartmentList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_DepartmentPageChange(e) {
      // 获取当前页码
      this.departmentReqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetDepartmentList();
    },
    /**
     * 重置
     */
    fun_DepartmentReset() {
      // 清空表单
      this.departmentForm = {
        zoneCode: null, // 区管代码
        borrowFlag: null, // 借平台标志
        departmentCode: null, // 部门代码
        departmentName: null, // 部门名称
      },
      // 重置分页
      this.departmentReqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetDepartmentList();
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_DepartmentClick(e) {
      switch (e) {
        case "添加":
          this.fun_DepartmentAdd();
          break;
        case "修改":
          this.fun_DepartmentEdit();
          break;
        case "删除":
          this.fun_DepartmentDel();
          break;
        default:
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_DepartmentHandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.departmentMultipleSelection = e;
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetDepartmentSelectVal(e, i) {
      // 赋值
      this.departmentForm[i] = e;
    },
    /**
     * 查看详情
     * @params e 点击的行数据
     * @author 付翔
     */
    fun_DepartmentDetails(e) {
      // 跳转详情页面
      this.$router.push({
        path: "/zoneCodeDetail",
        // 操作类型
        query: {
          id: e.val.id, // 主键
          type: "details", // 操作类型
          flag: "2", // 标志
        }
      });
    },
    /**
     * 点击新增按钮
     */
    fun_DepartmentAdd() {
      // 跳转详情页面
      this.$router.push({
        path: "/zoneCodeDetail",
        // 操作类型
        query: {
          type: "insert", // 操作类型
          flag: "2", // 标志
        }
      });
    },
    /**
     * 点击修改按钮
     */
    fun_DepartmentEdit() {
      // 判断是否勾选
      if (this.departmentMultipleSelection && this.departmentMultipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.departmentMultipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
        } else {
          // 跳转详情页面
          this.$router.push({
            path: "/zoneCodeDetail",
            // 操作类型
            query: {
              id: this.departmentMultipleSelection[0].id, // 主键
              type: "update", // 操作类型
              flag: "2", // 标志
            }
          });
        }
      }
    },
    /**
    * 删除
    */
    fun_DepartmentDel() {
      // 判断是否勾选
      if (this.departmentMultipleSelection && this.departmentMultipleSelection.length > 0) {
        // 主键集合
        let keys = [];
        // 遍历勾选
        for (const index in this.departmentMultipleSelection) {
          // 赋值主键集合
          keys[index] = this.departmentMultipleSelection[index].id;
        }
        // 弹出询问confirm
        this.$confirm("是否确定删除选中数据？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          // 请求，获取结果集
          fun_PostAction("/zoneDepartment/delete", {
            keys: keys
          }).then(res => {
            // 解构res.data
            const { msg } = res.data;
            // 操作成功
            this.$message.success(msg);
            // 获取一览表格数据
            this.fun_GetDepartmentList();
          });
        });
      }
      // 如果未进行勾选
      else {
        // 提示，并清除选中数据
        this.$alert("最少选择一条数据！", "warning");
      }
    },
  }
};
